












import { Component } from "vue-property-decorator";
import RegularPartBase from "./RegularPartBase";
import { STAFF_DIV_OT, STAFF_DIV_PT, STAFF_DIV_ST } from "#/const/officestaff";

@Component
export default class StaffDiv extends RegularPartBase {
  private get RegularStaffDiv() {
    if (this.officeHistory.business_div == 3) {
      const excludeStaffDivs = [STAFF_DIV_PT, STAFF_DIV_OT, STAFF_DIV_ST];
      return this.masters.nomal_staff_div.filter(
        staffDiv => !excludeStaffDivs.includes(Number(staffDiv.value))
      );
    }
    return this.masters.nomal_staff_div;
  }
}
